import { ReactElement, useState, useMemo } from 'react';
import WrapperContext from './context';
import StyledWrapper from './PageWrapperStyles';

type Props = {
  children: ReactElement;
};

function PageWrapper({ children }: Props): JSX.Element {
  const [searchInput, setSearchInput] = useState('');
  const value = useMemo(
    () => ({ searchInput, setSearchInput }),
    [searchInput],
  );

  return (
    <StyledWrapper>
      <div className="overlay" />
      <div className="content">
        <WrapperContext.Provider value={value}>
          {children}
        </WrapperContext.Provider>
      </div>
    </StyledWrapper>
  );
}

export default PageWrapper;
